// extracted by mini-css-extract-plugin
export default {"other":"index_other_Guvyr","judgesImg":"index_judgesImg_w-oo3"};